import { l } from '@manychat/manyui'

export const getCurrencyCode = (key, def = null) => {
  if (!key && !def) {
    return null
  }

  return l.getCurrencyCode(key || def)
}
